import { createBrowserRouter, Navigate } from 'react-router';

const page = (load: () => Promise<{ default: React.ComponentType }>) => async () => ({ Component: (await load()).default });

export const router = createBrowserRouter([
  { path: '/', element: <Navigate to="/overview" replace/> },
  { path: '/overview', lazy: page(() => import('../pages/OverviewPage')) },
  { path: '/sources', lazy: page(() => import('../pages/SourcesPage')) },
  { path: '/markets', lazy: page(() => import('../pages/MarketsPage')) },
  { path: '/journey', lazy: page(() => import('../pages/JourneyPage')) },
  { path: '/funnel', lazy: page(() => import('../pages/FunnelPage')) },
  { path: '/orders', lazy: page(() => import('../pages/OrdersPage')) },
  { path: '/orders/:id', lazy: page(() => import('../pages/OrderPage')) },
  { path: '/landings', lazy: page(() => import('../pages/LandingsPage')) },
  { path: '/landings/:id', lazy: page(() => import('../pages/LandingPage')) },
  { path: '/ads', lazy: page(() => import('../pages/AdsPage')) },
  { path: '/campaign', lazy: page(() => import('../pages/CampaignPage')) },
  { path: '*', lazy: page(() => import('../pages/NotFoundPage')) },
]);
